import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';

import CustomTeamImageWithDefault from '@/components/shared/custom/CustomTeamImageWithDefault';

const FixtureGamesPlayerComponent = ({ fixturePrediction, includeHome, includeAway }) => {
    if (!fixturePrediction) {
        return null;
    }

    const home = fixturePrediction?.teams?.home;
    const away = fixturePrediction?.teams?.away;

    const getTableRows = (rows, isBold) => {
        const fontWeight = isBold ? 600 : 400;
        return (
            <TableRow>
                {rows.map((row, index) => (
                    <TableCell
                        align={index === 0 ? 'left' : 'center'}
                        key={index}
                        colSpan={3}
                        className="first-row"
                        style={{ fontWeight: fontWeight }}
                    >
                        {row}
                    </TableCell>
                ))}
            </TableRow>
        );
    };

    const getSingleRow = (team) => {
        if (!team) return null;

        return (
            <TableRow>
                <TableCell align={'left'} colSpan={12}>
                    <CustomTeamImageWithDefault
                        teamId={team.id}
                        alt={'equipo'}
                        width={20}
                        height={20}
                    ></CustomTeamImageWithDefault>
                    <span className="title-tabs" style={{ marginLeft: 8 }}>
                        {team.name}
                    </span>
                </TableCell>
            </TableRow>
        );
    };

    const getTablesData = (team) => {
        if (!team) {
            return null;
        }

        return (
            <TableContainer component={Paper} className="datos-table-container mb-25">
                <Table className="data-table-games" size={'small'} aria-label="simple table">
                    <TableHead>
                        {getSingleRow(team)}
                        {getTableRows(['', 'Local', 'Visitante', 'Total'])}

                        {getTableRows(['Partidos disputados', '', '', ''], true)}
                    </TableHead>
                    <TableBody>
                        {getTableRows([
                            'Total',
                            team.league.fixtures.played.home,
                            team.league.fixtures.played.away,
                            team.league.fixtures.played.total,
                        ])}
                        {getTableRows([
                            'Victorias',
                            team.league.fixtures.wins.home,
                            team.league.fixtures.wins.away,
                            team.league.fixtures.wins.total,
                        ])}
                        {getTableRows([
                            'Empates',
                            team.league.fixtures.draws.home,
                            team.league.fixtures.draws.away,
                            team.league.fixtures.draws.total,
                        ])}
                        {getTableRows([
                            'Derrotas',
                            team.league.fixtures.loses.home,
                            team.league.fixtures.loses.away,
                            team.league.fixtures.loses.total,
                        ])}
                    </TableBody>
                </Table>
                <Table className="data-table-clean-sheet" size={'small'} aria-label="simple table">
                    <TableBody>
                        {getTableRows([
                            'Porterías a cero',
                            team.league.clean_sheet.home,
                            team.league.clean_sheet.away,
                            team.league.clean_sheet.total,
                        ])}
                    </TableBody>
                </Table>
                <Table className="data-table-failed-to-score" size={'small'} aria-label="simple table">
                    <TableBody>
                        {getTableRows([
                            'Sin anotar',
                            team.league.failed_to_score.home,
                            team.league.failed_to_score.away,
                            team.league.failed_to_score.total,
                        ])}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };

    return (
        <Box className="fixture-predictions-container">
            {includeHome && getTablesData(home)}
            {includeAway && getTablesData(away)}
        </Box>
    );
};

export default FixtureGamesPlayerComponent;
